export const buildGoogleCalendarLink = (
  name: string,
  startDate: Date,
  endDate: Date,
  details: string,
  location: string,
): string => {
  const regex = /-|:|\.\d\d\d/g

  const dates = `${startDate
    .toISOString()
    .replace(regex, '')}/${endDate.toISOString().replace(regex, '')}`
  return `http://www.google.com/calendar/render?action=TEMPLATE&text=${name}&dates=${dates}&details=${details}&location=${location}&trp=false&sprop=&sprop=name:`
}
